module.exports = __webpack_public_path__ + "static/media/order-review-expired.27f733cb.svg";